import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { ShareLink } from '#src/app/shared/hooks/share';

import type { PetitionMobileNativeShareLinkQuery, PetitionMobileNativeShareLinkQueryVariables } from './api.graphql';
import { PetitionMobileNativeShareLink } from './api.graphql';

export async function getPetitionMobileNativeShareLink({
	id,
	utilityContext,
}: {
	id: string;
	utilityContext: UtilityContext;
}): Promise<ShareLink | null> {
	const { gql } = utilityContext;

	const { data } = await gql.fetch<PetitionMobileNativeShareLinkQuery, PetitionMobileNativeShareLinkQueryVariables>({
		query: PetitionMobileNativeShareLink,
		variables: { id },
		rejectOnError: true,
	});

	return data.petition?.mobileNativeShareLink ?? null;
}
